import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Guide() {
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => { api.get("/articles").then(({data})=>setArticles(data)); }, []);
  const categories = ["All", ...Array.from(new Set(articles.map(a=>a.category)))];
  const list = cat === "All" ? articles : articles.filter(a=>a.category===cat);

  return (
    <div data-testid="guide-page">
      <section className="section-y pb-8">
        <div className="container-x max-w-3xl">
          <div className="overline">The Restore Guide</div>
          <h1 className="font-display text-5xl lg:text-6xl text-sage-800 mt-4 text-balance">Learn. Ask. Restore.</h1>
          <p className="mt-6 text-lg text-sage-800/70">Educational articles on wellness, IV therapy, supplements, peptides, healthy aging and more.</p>
        </div>
      </section>
      <section className="pb-24">
        <div className="container-x">
          <div className="flex gap-2 flex-wrap mb-10">
            {categories.map(c=>(
              <button key={c} onClick={()=>setCat(c)} data-testid={`guide-cat-${c.replace(/\s+/g,'-').toLowerCase()}`} className={`btn-pill text-xs px-4 py-2 border ${cat===c?"bg-sage-700 text-white border-sage-700":"border-sand-300 text-sage-800 bg-white hover:bg-sand-100"}`}>{c}</button>
            ))}
          </div>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {list.map(a=>(
              <Link key={a.id} to={`/guide/${a.slug}`} data-testid={`article-${a.slug}`} className="card-lift rounded-3xl bg-white border border-sand-200/60 overflow-hidden">
                {a.cover_image && <div className="aspect-[4/3] bg-sand-100"><img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" /></div>}
                <div className="p-6">
                  <div className="overline text-clay-600">{a.category}</div>
                  <div className="font-display text-xl text-sage-800 mt-2">{a.title}</div>
                  <div className="text-sm text-sage-800/65 mt-2 line-clamp-2">{a.excerpt}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
